import React, { useState, useEffect, useRef } from 'react'
import './index.scss'
import img_bg from '@/static/img/bg_3.jpg'
import { Carousel, Row, Col, Table, message, Button, Modal } from 'antd'
import NavLink from '@/components/NavLink'
import { useParams } from 'react-router-dom';
import Http from "@/utils/http";
import ConstValue from "@/utils/value";
import { useNavigate } from "react-router-dom";
import {
    CloudDownloadOutlined
} from '@ant-design/icons';

export default function Products3() {
    const [activtyKey, setActivtyKey] = useState(0);
    const [flag, setflag] = useState({});
    const [flag2, setflag2] = useState({});
    const [open, setOpen] = useState(false);

    const carRfe = useRef();
    const getParams = useParams();
    const [info, setInfo] = useState({});
    const [info2, setInfo2] = useState([{}]);
    const [info3, setInfo3] = useState([]);
    const [infoImg, setInfoImg] = useState([]);

    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate()
    const getBaceInfo = async () => {
        let res = await Http.to.items('Basic_information').readByQuery({
            sort: ['id'],
        });
        setInfo3(res.data);
    }
    const selectArr = [{
        src: img_bg
    }, {
        src: img_bg
    }, {
        src: img_bg
    }]
    const columns = [

        {
            title: 'Part No.',
            dataIndex: 'Part_No',
            key: '1',
            width: 79,
        },


        {
            title: 'Data Rate',
            dataIndex: 'Data_Rate',
            key: '5',
            width: 70,
        },
        {
            title: 'Reach',
            dataIndex: 'Reach',
            key: '6',
            width: 30,
        },
        {
            title: 'Wavelength',
            dataIndex: 'Wavelength',
            key: '7',
            width: 120,
        },
        {
            title: 'Transmitter',
            dataIndex: 'Transmitter',
            key: '8',
            width: 79,
        },
        {
            title: 'Receiver',
            dataIndex: 'Receiver',
            key: '9',
            width: 79,
        },
        {
            title: 'Connector',
            dataIndex: 'Connector',
            key: '10',
            width: 79,

        },
        {
            title: 'Temperature',
            dataIndex: 'Temperature',
            key: '11',
            width: 79,

        },
        // {
        //     title: 'Application',
        //     dataIndex: 'Application',
        //     key: '12',
        //     width: 79,

        // },
        {
            title: 'PD(Max)',
            dataIndex: 'Power_dissipationMax',
            key: '12',
            width: 79,

        },
        {
            title: 'Voltage Supply',
            dataIndex: 'Voltage_Supply',
            key: '12',
            width: 110,

        },
        // {
        //     title: 'Contact Sales',
        //     key: 'operation',
        //     fixed: 'right',
        //     width: 64,
        //     render: (e, t, index) => { return (e.part_no && (!flag[index]) ? ((!flag2[index]) ? (<div className='download'><a onClick={(item) => { download(e, 'data', index) }} ><CloudDownloadOutlined /></a> </div>) : <div className='svg_load'></div>) : <div className='download'><Button disabled type="link"><CloudDownloadOutlined style={{ fontSize: '20px' }} /></Button></div>) }
        // },
        {
            title: 'Contact Sales',
            key: 'operation',
            fixed: 'right',
            width: 64,
            render: (e, t, index) => { return <div className='download'><a onClick={(item) => { download(e, 'data', index) }} ><div className='email_icon'></div></a> </div> }
        },
    ];
    const columns1 = [

        {
            title: 'Part No.',
            dataIndex: 'part_no',
            key: '1',
            width: 79,
        },
        {
            title: 'Power',
            dataIndex: 'Power',
            key: '3',
            width: 64,
        },
        {
            title: 'Channel',
            dataIndex: 'Channel',
            key: '4',
            width: 64,
        },
        {
            title: 'Data Rate',
            dataIndex: 'data_rate',
            key: '5',
            width: 70,
        },
        {
            title: 'Reach',
            dataIndex: 'reach',
            key: '6',
            width: 50,
        },
        {
            title: 'Wavelength',
            dataIndex: 'wavelength',
            key: '7',
            width: 90,
        },
        {
            title: 'Transmitter',
            dataIndex: 'transmitter',
            key: '8',
            width: 79,
        },
        {
            title: 'Receiver',
            dataIndex: 'receiver',
            key: '9',
            width: 79,
        },
        {
            title: 'Interface',
            dataIndex: 'interface',
            key: '10',
            width: 79,

        },
        {
            title: 'Temperature',
            dataIndex: 'temperature',
            key: '11',
            width: 79,

        },
        {
            title: 'Application',
            dataIndex: 'application',
            key: '12',
            width: 79,

        },
        {
            title: 'download',
            key: 'operation',
            fixed: 'right',
            width: 64,
            render: (e, t, index) => { return (e.part_no && (!flag[index]) ? ((!flag2[index]) ? (<div className='download'><a onClick={(item) => { download(e, 'data', index) }} ><CloudDownloadOutlined /></a> </div>) : <div className='svg_load'></div>) : <div className='download'><Button disabled type="link"><CloudDownloadOutlined style={{ fontSize: '20px' }} /></Button></div>) }
        },
    ];
    async function download(e = {}, fileName = 'data', index) {
        setOpen(true)
    }
    const selectChange = (index) => {
        carRfe.current.goTo(index); setActivtyKey(index);
    }
    const toPage = (address, routerName) => {
        if (address.indexOf('http') !== -1) {
            window.open(address);
            return
        }
        navigate('/' + address);
    }
    
    // 辅助函数：检查HTML内容是否为空
    const isContentEmpty = (htmlContent) => {
        if (!htmlContent) return true;
        // 去除HTML标签
        const textContent = htmlContent.replace(/<[^>]*>/g, '').trim();
        // 检查是否为空或只有空格
        return textContent === '' || textContent === '&nbsp;';
    };

    useEffect(() => {
        getInfo();
        getBaceInfo();
    }, []);
    const getInfo = async () => {
    let res = await Http.to.items("Product_new/" + getParams?.id).readByQuery({
        sort: ['id'],
        filter: {}
    });
    
    // 改为精确匹配：使用 filter 而不是 search
    let res2 = await Http.to.items("Product_new").readByQuery({
        sort: ['id'],
        filter: {
            Name: { _eq: res.data.Name }  // 使用 _eq 进行精确匹配
        }
    });
    
    let infoarr = [];
    res2.data.forEach((item) => {
        if (item.Part_No) {
            infoarr.push(item)
        }
    })
    setInfo2(infoarr);
    
    // 修复图片处理 - 直接使用分割后的数组
    let imgArray = res?.data?.img ? res?.data?.img.split(';').map(item => item.trim()) : [];
    console.log('图片数组:', imgArray);

    setInfoImg(imgArray);
    setInfo(res.data)
}

    const cleanedDataSource = info2.map((data) => ({ ...data }));

    // 遍历每一列，除了最后一列
    for (let i = columns.length - 2; i >= 0; i--) {
        const column = columns[i];
        const dataIndex = column.dataIndex;

        // 检查该列的所有数据是否都为空
        const allEmpty = cleanedDataSource.every((data) => !data[dataIndex]);

        // 如果某列的所有数据都为空，将该列从列定义(columns)中删除
        if (allEmpty) {
            columns.splice(i, 1);

            // 同时，将数据源(cleanedDataSource)中对应列的数据也删除
            cleanedDataSource.forEach((data) => delete data[dataIndex]);
        }
    }
    const navInfo = {
        '1': 'Pluggable Transceiver',
        '2': 'Optical Engine',
        '3': 'NPO/CPO ELSFP & OE Connectivity'
    }
    
    // 检查Features和Application内容是否为空
    const hasFeatures = !isContentEmpty(info?.Features);
    const hasApplication = !isContentEmpty(info?.Application);
    
    return (
        <div className='products3'>
            {contextHolder}
            <NavLink title1={'Products · Solution'} link1={() => { toPage('Solution') }} title2={info?.Name} />
            {infoImg.length !== 0 &&
                (
                    <div className='top_bg'>
                        <div className='bg'>

                            <Carousel ref={carRfe} style={{ height: '100%' }} dots={false}  >

                                {infoImg.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            <img src={ConstValue.url + "assets/" + item} alt="" />
                                        </div>
                                    )

                                })}

                            </Carousel >
                        </div >
                        <div className="select">

                            {infoImg.map((item, index) => {
                                return (
                                    <div key={index} className={"item " + ((activtyKey === (index)) ? 'activtyitem' : '')} onClick={() => selectChange((index))}>
                                        <img src={ConstValue.url + "assets/" + item} alt="" />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            }

            <div className='content'>
                
                <div className='title1'>{info?.Name}</div>
            
                <Row justify={'center'}>

                    <Col xs={24} sm={24} xl={8}>
                        {/* 只有当Features有内容时才显示左侧区块 */}
                        {hasFeatures && (
                            <div className='left'>
                                <div className='title2'>
                                    Features
                                </div>
                                <div className='item_content' dangerouslySetInnerHTML={{ __html: info?.Features }}></div>
                            </div>
                        )}
                    </Col>
                    
                    {/* 只有当Application有内容时才显示右侧区块 */}
                    {hasApplication && (
                        <Col xs={24} sm={24} xl={8} className='leftborder'>
                            <div className='right'>
                                <div className='item'>
                                    <div className='title'>
                                        Application
                                    </div>
                                    <div className='item_content' dangerouslySetInnerHTML={{ __html: info?.Application }}></div>
                                </div>
                            </div>
                        </Col>
                    )}
                    
                    {/* 处理第二个Application字段（如果有的话） */}
                    {info?.application && !isContentEmpty(info?.application) && (
                        <Col xs={24} sm={24} xl={8} className='leftborder'>
                            <div className='right' style={{ marginTop: '24px', marginBottom: '24px' }}>
                                <div className='item'>
                                    <div className='title'>
                                        Application
                                    </div>
                                    <div className='item_content' dangerouslySetInnerHTML={{ __html: info?.application }}></div>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
                {info2.length !== 0 &&
                    (
                        <div className='table'>
                            <div className='table_content'>
                                <div className="title">SPECIFICATIONS</div>
                                <Table
                                    id="myTable"
                                    columns={columns}
                                    dataSource={cleanedDataSource}
                                    scroll={{ x: 1200 }}
                                    pagination={{ position: ['bottomCenter'], pageSize: 10, hideOnSinglePage: true }}
                                />
                            </div>
                        </div>
                    )}

            </div>
            <Modal
                centered
                open={open}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                footer={() => { }}
                width={480}
            >
                <div className='products_modal'>
                    <div className='products_modal_title'>
                        Contact us
                    </div>
                    <div className='products_modal_email' dangerouslySetInnerHTML={{ __html: info3?.Email }}></div>
                    <div className='products_modal_footer'>
                        Please send us an email
                    </div>
                </div>
            </Modal>
        </div>
    );
}